export const setUnitOffer = (unitOffers) => ({
  type: 'SET_UNIT_OFFER',
  unitOffers,
});

export const setCurrentUnitOffer = (unitOffers) => {
  return (dispatch) => {
    dispatch(setUnitOffer(unitOffers));
  };
};
